import { Component, OnInit } from "@angular/core";

declare var MapmyIndia: any; // Declaring Mapmyindia
declare var L: any; // Declaring L
@Component({
  selector: "app-business-sample",
  templateUrl: "./business-sample.component.html",
  styleUrls: ["./business-sample.component.scss"],
})
export class BusinessSampleComponent implements OnInit {
  map: any;
  markers = [];
  imgModal: boolean = false;
  imgUrl;

  constructor() {}

  ngOnInit(): void {
    this.mapmyindia_removeMarker();

    this.map = new MapmyIndia.Map("map", {
      center: [
        '18.9918357',
        '72.8315902',
      ],
      zoom: 15,
      zoomControl: true,
      hybrid: true,
    });
    var postion = new L.LatLng(
      '18.9918357',
      '72.8315902',
    ); /*WGS location object*/
    let mark = this.addMarker(
      postion,
      "",
      "Address location",
      false
    ); /*call the add marker function*/
    this.markers.push(mark);
    this.map.setView(mark.getLatLng());
  }

  openImg() {
    // this.imgUrl = args;
    console.log(this.imgModal);
    this.imgModal = !this.imgModal;
  }

  mapmyindia_removeMarker() {
    var markerlength = this.markers.length;
    if (markerlength > 0) {
      for (var i = 0; i < markerlength; i++) {
        this.map.removeLayer(
          this.markers[i]
        ); /* deletion of marker object from the map */
      }
    }
    delete this.markers;
    this.markers = [];
  }

  addMarker(position, icon, title, draggable) {
    /* position must be instance of L.LatLng that replaces current WGS position of this object. Will always return current WGS position.*/
    let mk;
    if (icon == '') {
      mk = new L.Marker(position, {
        draggable: draggable,
        title: title,
      }); /*marker with a default icon and optional param draggable, title */
      // mk.bindPopup(title);
    } else {
      mk = new L.Marker(position, {
        icon: icon,
        draggable: draggable,
        title: title,
      }); /*marker with a custom icon */
      // mk.bindPopup(title);
    }
    this.map.addLayer(mk); /*add the marker to the map*/
    return mk;
  }
}
